<template>
  <div class="text-textColor">
    <transition name="fade">
      <div
        v-if="showEditGoal"
        class="bg-black fixed bg-opacity-70 inset-0 z-50 h-auto w-full overflow-x-scroll"
      >
        <div
          class="fixed center-h-v bg-white rounded-md shadow-2xl sm:w-2/3 w-full m-auto"
        >
          <div class="flex justify-between items-center border-b-1.5 p-3">
            <!-- {{ info }} -->
            <p class="text-base font-bold">Edit Objective</p>
            <img
              v-if="!loading"
              class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md"
              src="@/assets/icons/cross-white.png"
              @click="close()"
            />
          </div>
          <div class="grid grid-cols-1 sm:grid-cols-3 p-4 gap-5">
            <div class="text-sm">
              <label class="block pb-1">Goal Name</label>
              <input
                type="text"
                class="p-2 bg-gray-200 rounded-full w-full"
                placeholder="Goal Name"
                v-model="info.GoalName"
              />
            </div>

            <div class="text-sm">
              <label class="block pb-1">Start Date</label>
              <input
                type="text"
                onfocus="(this.type='date')"
                onbur="(this.type='text')"
                class="rounded-xl w-full pl-4 py-3 bg-gray-200 text-sm"
                v-model="info.StartDate"
                readonly
              />
            </div>

            <div class="text-sm">
              <label class="block pb-1">End Date</label>
              <input
                type="text"
                onfocus="(this.type='date')"
                onbur="(this.type='text')"
                class="rounded-xl w-full pl-4 py-3 bg-gray-200 text-sm"
                v-model="info.EndDate"
                readonly
              />
            </div>

            <div class="text-sm">
              <label class="block pb-1">Goal Measure</label>
              <div
                class="flex flex-wrap gap-2 justify-between bg-gray-200 rounded-md px-2"
                style="padding-top: 0.7rem; padding-bottom: 0.6rem"
              >
                <!-- Number Radio Button -->
                <label class="b-contain">
                  <span>Number</span>
                  <input
                    type="radio"
                    name="measure"
                    value="Number"
                    v-model="info.GoalMeasure"

                  />
                  <div class="b-input"></div>
                </label>
                <!-- Text Radio Button -->
                <label class="b-contain">
                  <span>Text</span>
                  <input
                    type="radio"
                    name="measure"
                    value="Text"
                    v-model="info.GoalMeasure"

                  />
                  <div class="b-input"></div>
                </label>
                <!-- Date Radio Button -->
                <label class="b-contain">
                  <span>Date</span>
                  <input
                    type="radio"
                    name="measure"
                    value="Date"
                    v-model="info.GoalMeasure"

                  />
                  <div class="b-input"></div>
                </label>
              </div>
            </div>

            <div class="text-sm">
              <label class="block pb-1">Target</label>
              <input
                :type="info.GoalMeasure"
                v-model="formattedTarget"
                class="rounded-xl w-full pl-4 py-3 bg-gray-200 text-sm"
              />
            </div>
            <div class="text-sm">
              <label class="block pb-1">Goal Weight (%)</label>
              <input
                  v-model="info.Weight"
                  required
                  type="text"
                  class="rounded-xl w-full pl-4 py-3 bg-gray-200 text-sm"
              />
            </div>
          </div>
          <div class="p-4">
            <label class="block pb-1">Description</label>
            <textarea
              v-model="info.Description"
              class="p-2 bg-gray-200 rounded-xl w-full"
              rows="8"
            ></textarea>
          </div>
          <div class="flex justify-end">
            <div class="flex justify-end p-5">
              <button
                  class="bg-gray-400 hover:bg-primary rounded-full px-5 text-sm text-white py-3"
                  @click="saveData('Draft')"
              >
                Save Draft
              </button>
            </div>
            <div class="flex justify-end p-5">
              <button
                  class="bg-primary rounded-full px-5 text-sm text-white py-3"
                  @click="saveData('Submitted')"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import {mapGetters} from "vuex";
import moment from "moment";

export default {
  name: "AddGoal",
  props: ["showEditGoal", "info", "handleEditCallback"],

  data() {
    return {
      loading: false,
      targetType: "",
      selectedType: "single",
      GoalMeasure: "",
    };
  },
  created() {

  },
  computed: {
    ...mapGetters(['getOrganization', 'getToken']),
    displayValue() {
      return this.isFocused ? this.rawInput : `${this.info.GoalWeight}%`;
    },
    formattedTarget:{
      get(){
        if(this.info.GoalMeasure==="Date"){
          const parts = this.info.Target.split("/");
          return `${parts[2]}-${parts[1]}-${parts[0]}`
        }
        return this.info.Target
      },
      set(value){
        if (this.info.GoalMeasure==="Date"){
          const parts = value.split("-");
          this.info.Target = `${parts[2]}-${parts[1]}-${parts[0]}`
        } else {
          this.info.Target = value
        }
      }
    }
  },
  methods: {
    onInput(event) {
      let value = event.target.value;

      // Remove non-numeric characters except for a single decimal point
      value = value.replace(/[^0-9.]/g, '');

      // Ensure only one decimal point is allowed
      const decimalIndex = value.indexOf('.');
      if (decimalIndex !== -1) {
        // Keep only the first decimal point and remove others
        value =
            value.slice(0, decimalIndex + 1) +
            value.slice(decimalIndex + 1).replace(/\./g, '');
      }

      // Convert to number
      let numericValue = parseFloat(value);

      if (numericValue > 100) {
        this.inputError = 'Weight cannot exceed 100%';
        setTimeout(() => {
          this.rawInput = '';
          this.info.GoalWeight = '';
        }, 2000);
      }

      // Ensure it's a multiple of 5
      // if (numericValue % 5 !== 0) {
      //   numericValue = Math.round(numericValue / 5) * 5;
      // }

      // Update raw input and model
      this.rawInput = isNaN(numericValue) ? '' : numericValue.toString();
      this.info.GoalWeight = isNaN(numericValue) ? 0 : numericValue;
    },
    onFocus() {
      // On focus, show the raw input value
      this.isFocused = true;
      this.rawInput = this.info.GoalWeight.toString();
    },
    onBlur() {
      // On blur, show the formatted value
      this.isFocused = false;
    },
    clearCustomWeight() {
      this.info.CustomWeight = null;
    },
    clearGoalWeight() {
      this.info.GoalWeight = null;
    },
    toggleGoalMeasure(type) {
      this.targetType = type;
      this.info.GoalMeasure = type;
    },
    close() {
      this.$emit("close");
    },
    saveData(type) {
      if (
        !this.info.GoalName ||
        !this.info.GoalMeasure ||
        !this.info.StartDate ||
        !this.info.EndDate ||
        !this.info.Target ||
          !this.info.Weight
      ) {
        this.$notify.error({
          title: "Failure",
          message: `Please fill in all required fields`,
        });
        return;
      }
      console.log(this.info.GoalMeasure,this.info.Target, moment(this.info.Target).format('dd/MM/yyyy'))
      const data = {
       ObjectiveId: this.info.ObjectiveId,
        GoalName: this.info.GoalName,
        GoalMeasure: this.info.GoalMeasure,
        Target:this.info.Target,
        Description: this.info.Description,
        StrategicGoalId:this.info.StrategicGoalId,
        SubmissionStatus:type,
        Weight:parseInt(this.info.Weight),
        StartDate: new Date(new Date(this.info.StartDate).setDate(new Date(this.info.StartDate).getDate() + 1)).toISOString().split("T")[0],
        EndDate: new Date(new Date(this.info.EndDate).setDate(new Date(this.info.EndDate).getDate() + 1)).toISOString().split("T")[0],

      };
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      console.log(data)
      console.log(this.info)
      axios
        .put(`${this.getOrganization}/performance/objective/${this.$ApiVersion}/edit`, data,options )
        .then((response) => {
          if (response.status == 200) {
            this.$notify({
              title: "Success",
              message: "Data saved successfully.",
              type: "success",
            });
            this.$emit("close");
            this.handleEditCallback();
          }
        })
        .catch((error) => {
          console.error("Error saving data:", error);
          this.$notify.error({
            title: "Failure",
            message: "Error occured while saving your changes.",
          });
        });
    },
  },
};
</script>

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>
